import { InlineStack, Paragraph, Stack, Text, Toggle, Tooltip } from '@customerio/pluma-components/react';

export const NO_EVENTS_TOOLTIP = 'To enable you must select at least one event to send.';

const STATE_LABEL_ID = 'webhook-state-label';

type WebhookStateFieldProps = {
  isEnabled: boolean;
  /** The webhook has no events selected, so it cannot be turned on at all. */
  isForceDisabled: boolean;
  isDisabled: boolean;
  onChange: (isEnabled: boolean) => void;
};

/**
 * The enabled/disabled switch, shown only for a webhook that already exists — a webhook being
 * created chooses its state through the save buttons instead.
 */
export function WebhookStateField({ isEnabled, isForceDisabled, isDisabled, onChange }: WebhookStateFieldProps) {
  return (
    <InlineStack alignBlock="center" alignInline="space-between">
      <Stack gap="050">
        <Text as="div" id={STATE_LABEL_ID} text="product-h4">
          Webhook state
        </Text>
        <Paragraph mb="0" size="xs">
          Note: If you disable, your webhook will be saved, but not send any events.
        </Paragraph>
      </Stack>
      <Tooltip isDisabled={!isForceDisabled} content={NO_EVENTS_TOOLTIP} isCustom>
        {(context) => (
          <Toggle
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
            data-test-webhook-status
            isChecked={isEnabled}
            isDisabled={isDisabled || isForceDisabled}
            onChange={(event) => onChange(event.currentTarget.checked)}
            ariaLabelledby={STATE_LABEL_ID}
            size="sm"
          />
        )}
      </Tooltip>
    </InlineStack>
  );
}
